import OaApiService from './OaApiService';

export default class BuyerService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByKeyUrl = '/BuyerREST/buyer';
    this.createUrl = '/BuyerREST/buyer';
    this.updateUrl = '/BuyerREST/buyer';
  }

  getListingsForAgent(agentKey) {
    return new Promise((resolve, reject) => {
      this.get('/AgentREST/agent-buyer-properties', {}, agentKey)
        .then((listings) => {
          resolve(listings);
        })
        .catch((error) => {
          // This endpoint returns false when the agent has no listing yet
          // We don't want to throw an error in that case but expect an empty array instead
          if (error === 'Error getting BuyerProperties by agentkey') {
            resolve([]);
          } else {
            reject(error);
          }
        });
    });
  }

  getListing(buyerPropertyKey) {
    return this.get('/BuyerREST/buyer-property', {}, buyerPropertyKey);
  }

  getListingPhotos(buyerPropertyKey) {
    return this.get('/BuyerREST/buyer-property-photos', {}, buyerPropertyKey);
  }

  addListing(data) {
    return this.post('/BuyerREST/buyer-property', data);
  }

  addListingPhoto(data, buyerPropertyKey) {
    return this.post('/BuyerREST/buyer-property-photo', data, buyerPropertyKey);
  }
  // $.ajax({
  //     url: service_endpoint_root + "/v1/BuyerREST/" + buyerPropertyKey,
  //     type: "POST",
  //     dataType: "json",
  //     data: data,
  //     enctype: 'multipart/form-data',
  //     processData: false,  // Important!
  //     contentType: false,
  //     cache: false
  // }).done(function (data) {
  //     resolve(data)
  // });

  updateListing(data) {
    return this.put('/BuyerREST/buyer-property', data);
  }
}
